import React, { useEffect, useRef, useState } from "react";
import API from '../../Services/Dashboard';
import ComboProductModal from "../ProductTypeModal/ComboProductModal";
import DashboardComponent from "../../Pages/Dashboard/index";
import { toast } from "react-toastify";
import API2 from '../../Services/Login';
const CardModal = () => {
    const inputRef = useRef(null);
    const [showMainModal, setShowMainModal] = useState(false);
    const [showNewModal, setShowNewModal] = useState(false);
    const [value, setValue] = useState("");
    const [comboProduct, setComboProduct] = useState([]);
    const [comboProductStatus, setProductStatus] = useState(false);
    const [showDashboard, setShowDashboard] = useState(false);
    const [cardDetails, setCardDetails] = useState([]);
    const [password, setPassword] = useState("");
    const [scanFirst, setScanFirst] = useState("");

    useEffect(() => {
        inputRef.current?.focus();
    }, []);


        useEffect(() => {
        const handleClick = () => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        };
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, []);


    useEffect(() => {
        const productType = localStorage.getItem("selectedProductTypeId")
        if (productType != null) {
            setShowMainModal(true);
        }
        else {
            window.location.replace("/Login");
        }
        console.log('localStorage.getItem("selectedProductTypeId")', localStorage.getItem("selectedProductTypeId"))
        console.log('localStorage.getItem("isWaiverRequired")', localStorage.getItem("isWaiverRequired"))


    }, []);

    const handleHomeClick = () => {
        setShowMainModal(false);
        setShowNewModal(true);
    };

    const handleVerifyClick = () => {
        setShowMainModal(true);
        setShowNewModal(false);
    };

    const getCardSwipeData = async () => {
        try {
            const response = await API.getCardSwipe(value);
            console.log("........", response)
            setCardDetails(response?.data?.data || []);
            if (response.status === 200) {
                if (Array.isArray(response.data.data) && response.data.data.length === 0) {
                    setProductStatus(true);
                } else {
                    await getComboProduct();
                    setShowMainModal(false);
                }
            } else {
                toast.error("Unexpected server response.");
            }

        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    const message = error.response.data?.message || "Card not found";
                    toast.error(message);
                    setProductStatus(true);
                    setCardDetails([]);
                }
                else if (error.response.status === 403) {
                    window.location.replace("/Login")
                }
                else {
                    toast.error(`Server error: ${error.response.status}`);
                }
            } else {
                toast.error("Network or unexpected error occurred.");
            }
            console.error("Error fetching card swipe data:", error);
        }
    };



    // const getComboProduct = async () => {
    //     setScanFirst(true);
    //     const payload = {
    //         card_no: value,
    //         product_type_id: localStorage.getItem("selectedProductTypeId")
    //     };
    //     const response = await API.getComboProduct(payload);
    //     if (Array.isArray(response?.data?.data) && response.data.data.length === 0) {
    //         setShowDashboard(true);
    //     } else {
    //         setProductStatus(true);
    //         setComboProduct(response?.data?.data || []);
    //     }
    // };
    const getComboProduct = async () => {
        try {
            setScanFirst(true);
            const payload = {
                card_no: value,
                product_type_id: localStorage.getItem("selectedProductTypeId")
            };
            const response = await API.getComboProduct(payload);
            if (Array.isArray(response?.data?.data) && response.data.data.length === 0) {
                setShowDashboard(true);
            } else {
                setProductStatus(true);
                setComboProduct(response?.data?.data || []);
            }
        } catch (error) {
            if (error?.response?.status === 403) {
                window.location.replace("/Login")
            } else {
                toast.error("Failed to fetch combo products.");
                console.error("Combo product fetch error:", error);
            }
        }
    };




    // const handleVerifyPassword = async () => {
    //     if (!password) {
    //         toast.error("Password are required!");
    //         return;
    //     }
    //     const payload = {
    //         email: localStorage.getItem("email"),
    //         password: password,
    //         location_id: parseInt(localStorage.getItem("location_id")),
    //     }
    //     console.log('paa', payload);
    //     try {
    //         const response = await API2.VerifyLocation(payload);
    //         if (response?.status === 200 && response?.data?.success) {
    //             console.log('rrrr', response?.data?.message)
    //             window.location.replace("/ProductType");
    //         } else {
    //             toast.error(response?.data?.message || "Unexpected error occurred!");
    //         }
    //     } catch (error) {
    //         if (error?.response?.status === 403) {
    //             window.location.replace("/Login")

    //         } else {
    //             toast.error("Invalid verify password or network error.");
    //         }
    //     }
    // }

    const handleVerifyPassword = async () => {
        const email = localStorage.getItem("email");
        const locationId = localStorage.getItem("location_id");
        if (!email || !locationId) {
            toast.error("Session expired. Please log in again.");
            window.location.replace("/Login");
            return;
        }
        if (!password) {
            toast.error("Password is required!");
            return;
        }
        const payload = {
            email,
            password,
            location_id: parseInt(locationId),
        };
        console.log('paa', payload);
        try {
            const response = await API2.VerifyLocation(payload);
            if (response?.status === 200 && response?.data?.success) {
                console.log('rrrr', response?.data?.message);
                window.location.replace("/ProductType");
            } else {
                toast.error(response?.data?.message || "Unexpected error occurred!");
            }
        } catch (error) {
            if (error?.response?.status === 403) {
                toast.error("Access denied. Please log in again.");
                window.location.replace("/Login");
            } else {
                toast.error("Invalid verify password or network error.");
            }
        }
    };



    return (
        <div>
            {showMainModal && (
                <div className="modal d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content position-relative">
                            <button
                                className="btn-secondary  position-absolute"
                                style={{ top: 10, right: 10 }}
                                onClick={handleHomeClick}
                            >
                                Logout
                            </button>
                            {/* <div className="modal-body my-5" style={{ height: "300px", width: "500px" }}>
                                <div className="row justify-content-center mt-3">
                                    <input
                                        ref={inputRef}
                                        type="text"
                                        // className="form-control"
                                        className={`form-control ${scanFirst && !value ? "border-danger" : ""}`}
                                        value={value}
                                        placeholder="TAP THE CARD"
                                        onChange={(e) => {
                                            const inputValue = e.target.value.replace(/\D/g, "");
                                            setValue(inputValue);
                                        }}
                                        onKeyDown={(e) => {
                                            // if (e.key === 'Enter' && value.length === 10) {
                                            if (e.key === 'Enter') {
                                                getCardSwipeData();
                                            }
                                        }}
                                        style={{
                                            height: "220px",
                                            width: "400px",
                                            textAlign: "center",
                                            fontSize: "27px",
                                            fontWeight: "bold",
                                            color: "#9269c8",
                                            //display:"none"
                                        }}
                                        autoFocus
                                    />
                                </div>
                            </div> */}
                            <div
                                className="modal-body my-5 position-relative d-flex justify-content-center align-items-center"
                                style={{ height: "300px", width: "500px" }} >
                                <p
                                
                                    style={{
                                        fontSize: "28px",
                                        fontWeight: "bold",
                                        color: "#9269c8",
                                        borderRadius: "10px",
                                        textAlign: "center",
                                        zIndex: 2,
                                        position: "absolute",
                                    }}
                                >
                                    TAP THE CARD
                                </p>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    className={`form-control ${scanFirst && !value ? "border-danger" : ""}`}
                                    value={value}
                                    onChange={(e) => {
                                        const inputValue = e.target.value.replace(/\D/g, "");
                                        setValue(inputValue)
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            getCardSwipeData();
                                        }
                                    }}
                                    style={{
                                        height: "220px",
                                        width: "400px",
                                        textAlign: "center",
                                        fontSize: "27px",
                                        fontWeight: "bold",
                                        color: "transparent",
                                        caretColor: "transparent",
                                        backgroundColor: "#ccc",
                                        border: "1px solid",
                                        position: "absolute",
                                        zIndex: 1
                                    }}
                                    autoFocus
                                    tabIndex={0}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Verify Password Modal */}
            {showNewModal && (
                <div className="modal d-block" tabIndex="-1" style={{ background: "rgba(0,0,0,0.5)" }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Verify Your Password</h5>
                                <button className="btn-close" onClick={handleVerifyClick} />
                            </div>
                            <div className="modal-body">
                                <input className="form-control rounded-0" type="password"
                                    id="password" placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} />

                                <button className="btn btn-secondary rounded-0 form-control my-3" onClick={handleVerifyPassword}>Verify Password</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {comboProduct.length > 0 && (
                <ComboProductModal
                    comboProductStatus={comboProductStatus}
                    comboProduct={comboProduct}
                    cardDetails={cardDetails}
                    onClose={() => {
                        setProductStatus(false);
                        setShowMainModal(true);
                    }}
                />
            )}

            {/* Dashboard Component */}
            {showDashboard && <DashboardComponent cardDetails={cardDetails} />}
        </div>
    );
};

export default CardModal;
